<template>
	<div>
		<div class="container">
			<header>
				<div class="row">
					<div class="col-md-12">
						<a href="https://redesrurais.org.br/">
							<img alt src="../assets/redes-logo.png" />
						</a>
					</div>
				</div>
			</header>
		</div>
		<div class="container">
			<nav class="navbar navbar-expand-md navbar-dark navegacao">
				<button class="navbar-toggler" type="button" data-toggle="collapse" aria-expanded="false" aria-label="Toggle navigation">
					<span class="navbar-toggler-icon"></span>
				</button>

				<div class="collapse navbar-collapse" id="navbarsExampleDefault">
					<ul class="navbar-nav mr-auto">
						<li class="nav-item active">
							<router-link to="/home"><a class="nav-link">Espaço do Associado</a></router-link>
						</li>
					</ul>
					<NavBarMenu v-if="showMenu" />
				</div>
			</nav>
		</div>
	</div>
</template>

<script>
import NavBarMenu from '@/components/NavBarMenu.vue';

export default {
	name: 'NavBar',
	components: {
		NavBarMenu,
	},
	props: {
		showMenu: Boolean,
	},
};
</script>

<style scoped></style>
